import { create } from 'zustand'

import { Promotion } from '../types/promotion.type'

type OperationType = 'add' | 'edit' | 'view' | null

type PromotionForm = {
  promotionSelected: Promotion | null
  operationType: OperationType
  formData: {
    cliente: string
    idCliente: number | null
    dataVisita: string
    promotor: string
    idPromotor: number | null
    status: string
    observacoes: string
  }
  isSubmitting: boolean
  hasChanges: boolean
}

type PromotionFormStore = {
  promotionForm: PromotionForm
  actions: {
    setPromotionSelected: (promotion: Promotion | null) => void
    setOperationType: (type: OperationType) => void
    setFormData: (data: Partial<PromotionForm['formData']>) => void
    resetFormData: () => void
    setIsSubmitting: (isSubmitting: boolean) => void
    setHasChanges: (hasChanges: boolean) => void
    clearPromotionForm: () => void
  }
}

const initialState: PromotionForm = {
  promotionSelected: null,
  operationType: null,
  formData: {
    cliente: '',
    idCliente: null,
    dataVisita: '',
    promotor: '',
    idPromotor: null,
    status: '',
    observacoes: '',
  },
  isSubmitting: false,
  hasChanges: false,
}

const promotionFormStore = create<PromotionFormStore>((set) => ({
  promotionForm: initialState,
  actions: {
    setPromotionSelected: (promotion) =>
      set((state) => {
        const newState = { ...state }
        newState.promotionForm.promotionSelected = promotion

        return newState
      }),
    setOperationType: (type) =>
      set((state) => {
        const newState = { ...state }
        newState.promotionForm.operationType = type
        return newState
      }),
    setFormData: (data) =>
      set((state) => {
        const newState = { ...state }
        newState.promotionForm.formData = {
          ...newState.promotionForm.formData,
          ...data,
        }
        newState.promotionForm.hasChanges = true
        return newState
      }),
    resetFormData: () =>
      set((state) => {
        const newState = { ...state }
        newState.promotionForm.formData = initialState.formData
        newState.promotionForm.hasChanges = false
        return newState
      }),
    setIsSubmitting: (isSubmitting) =>
      set((state) => {
        const newState = { ...state }
        newState.promotionForm.isSubmitting = isSubmitting
        return newState
      }),
    setHasChanges: (hasChanges) =>
      set((state) => {
        const newState = { ...state }
        newState.promotionForm.hasChanges = hasChanges
        return newState
      }),
    clearPromotionForm: () =>
      set((state) => {
        const newState = { ...state }
        newState.promotionForm = initialState
        return newState
      }),
  },
}))

export const usePromotionFormStore = () => {
  const store = promotionFormStore()
  return {
    promotionSelected: store.promotionForm.promotionSelected,
    operationType: store.promotionForm.operationType,
    formData: store.promotionForm.formData,
    isSubmitting: store.promotionForm.isSubmitting,
    hasChanges: store.promotionForm.hasChanges,
  }
}

export const usePromotionFormStoreAction = () => promotionFormStore((state) => state.actions)